<template>
  <div class="publicDetail">
    <div class="mainContent">
      <div class="title">{{ datas.headline ? datas.headline : datas.title }}</div>
      <div class="time-source">
        <span>{{datas.source}}</span>
        <span>{{datas.createtime | times}}</span>
      </div>
      <div class="content" v-html="datas.memo">
        <!-- <img src="" alt="">
        <p v-for="(content,index) in contents" :key="index" v-text="content.cont"></p>-->
      </div>
    </div>
    <funFooter
      v-if="name"
      :id="id"
      :dbnum="dbnum"
      :zan="zan"
      :collect="collect"
      @zan="clickZan"
      @collect="clickCollect"
      :headline="headline"
    />
  </div>
</template>

<script>
import { getShare, wxLogin } from '../api/wxShareApi'
import { getJSSDK } from '../utils/wxShare/wxShare'

import funFooter from "./component/funFooter";
export default {
  data() {
    return {
      datas: "",
      contents: "",
      id: this.$route.query.id,
      dbnum: this.$route.query.dbnum,
      zan: false,
      collect: false,
      headline: "",
      desc: '',
      shareTitle: '',
      img: '',
      iid: 0
    };
  },
  components: {
    funFooter
  },
  created() {
    document.body.scrollTop = 0;
    this.getMsg();
  },
  mounted: function() {
    document.body.scrollTop = 0;
    // this.getMsg();
    // this.id = this.$route.query.id
  },
  methods: {
    getMsg() {
      this.axios
        .get(
          `/api/Main/getNewsDetail?typeid=${this.dbnum}&id=${
            this.$route.query.id
          }&uid=${sessionStorage.getItem("id")}`
        )
        .then(e => {
          // console.log(e.data);
          if (e.data.code == 0) {
            this.headline = e.data.msg.headline;
            this.datas = e.data.msg;
            this.shareTitle = this.datas.headline ? this.datas.headline : this.datas.title
            // console.log('shareTitle2', this.shareTitle)
            this.img = e.data.msg.img && e.data.msg.img.split(',')[0]
            this.iid = e.data.msg.id
            console.log(this.img)
            if (e.data.status === 1) {
              this.zan = true;
            }
            if (e.data.state === 1) {
              this.collect = true;
              console.log('this.collect', this.collect)
            }
            this.share()
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    /* wx share */
    share() {
      // console.log('https://dp.djplus.cn' + this.$route.fullPath)
      let dataForWeixin = {
        title: this.shareTitle,
        desc: this.shareTitle,
        // linkurl: `https://dp.djplus.cn/publicDetail?title=${this.$route.query.title}&id=${this.iid}&dbnum=0`,
        linkurl: 'https://dp.djplus.cn' + this.$route.fullPath,
        img: `https://dpadmin.djplus.cn/Pimg/${this.img}`,
      }
      console.log('params: ', dataForWeixin)
      console.log('window.location.href: ', window.location.href)
      getShare({ url: window.location.href }).then((res) => {
        console.log('getShare res: ', res);
        if (res.code == 0) {
          getJSSDK(res, dataForWeixin);
        }
      });
    },
    clickZan(name) {
      this.zan = name;
    },
    clickCollect(name) {
      this.collect = name;
    }
  },
  computed: {
    name: function() {
      return sessionStorage.getItem("roleid") == "6" ? false : true;
    }
  }
};
</script>

<style lang="scss" scoped>
.publicDetail {
  .zans {
    display: flex;
    width: 100%;
    position: fixed;
    bottom: 0;
    align-items: center;
    border-top: 0.01rem solid #e6e6e6;
    z-index: 9;
    background: #fff;
    .redColor {
      color: red;
    }
    div {
      width: 50%;
      text-align: center;
      line-height: 3;
      &:nth-child(1) {
        border-right: 0.01rem solid #e6e6e6;
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
        vertical-align: text;
      }
    }
  }
  .mainContent {
    .content {
      width: 100%;
      text-align: center;
      // text-indent: 0.5rem;
      margin-top: 0.3rem;
      line-height: 2;
    }
    .time-source {
      display: flex;
      justify-content: space-between;
      color: #999999;
    }
    .title {
      font-weight: bold;
      font-size: 0.36rem;
      line-height: 2;
    }
    width: 94%;
    margin: 0 auto;
  }
  background: #fff;
  padding-top: 1rem;
  font-size: 0.3rem;
  min-height: 100vh;
  padding-bottom: 1.5rem;
}
</style>
<style lang="scss" >
.mainContent {
  video,
  img {
    width: 100%;
  }
  table {
    width: 100% !important;
  }
  
}
</style>